import { observable } from "mobx";

class UIStore {
  @observable contractModalOpen = false;
  @observable projectModalOpen = false;
}

export default UIStore;
